import { render, staticRenderFns } from "./TravelPrintCertificate.vue?vue&type=template&id=52319077&"
import script from "./TravelPrintCertificate.vue?vue&type=script&lang=js&"
export * from "./TravelPrintCertificate.vue?vue&type=script&lang=js&"
import style0 from "./TravelPrintCertificate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TravelPrintCertificate.vue"
export default component.exports